import { useEffect } from "react";

const LANGS = ["en", "fr", "de"];
const PAGES = ["about", "contact", "nmt-pro-package", "quote", "services", "team", "tta", "privacy"];

const pageFile = (pathname) => {
  const parts = pathname.replace(/\.html$/, "").split("/").filter(Boolean);
  const lang = LANGS.includes(parts[0]) ? parts.shift() : null;
  const page = PAGES.includes(parts[0]) ? parts[0] : null;
  if (parts.length > 1 || (parts.length === 1 && !page)) return null;
  if (page === "privacy") return "privacy";
  if (lang && page) return `${lang}_${page}`;
  return lang || page || "index";
};

const isPhone = () => {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  return window.matchMedia("(pointer: coarse)").matches && Math.min(window.screen.width, window.screen.height) < 600;
};

const inject = (html) => {
  const api = process.env.REACT_APP_BACKEND_URL || "";
  const tag = `<script>window.__ATRADO_API__=${JSON.stringify(api)};</script><script src="/atrado-form.js"></script><script src="/closures.js" defer></script><script src="/cookie-notice.js" defer></script><style>#dm .p_hfcontainer div.u_1977991059.multilingualWidget{margin-left:auto!important;margin-right:40px!important;width:auto!important}</style>`;
  return html.replace("</head>", `${tag}</head>`);
};

export default function App() {
  useEffect(() => {
    if (window.__atradoLoading) return;
    window.__atradoLoading = true;
    const file = pageFile(window.location.pathname) || "index";
    fetch(`/${isPhone() ? "site-m" : "site"}/${file}.html`)
      .then((r) => r.text())
      .then((html) => {
        document.open();
        document.write(inject(html));
        document.close();
      })
      .catch(() => {});
  }, []);
  return null;
}
